<template>
    <el-table-column v-bind="$attrs"  v-if="$scopedSlots.default" >
        <template slot-scope="scope" >
            <slot  :column="scope.column" :store="scope.store" :_self="scope._self" :index="scope.$index" :row="scope.row" ></slot>
        </template>
    </el-table-column>
    <el-table-column v-bind="$attrs" v-else>

    </el-table-column>
</template>
<script>
export default {
    data() {
        return {
        }
    },
    created() {

    },
    mounted() {
        // console.debug(this)
    },  
}
</script>

<style lang="less" scoped>
</style>